import { BasicRequest } from "./basicRequest";
import { ConsumerRegistration } from "./ConsumerRegistration";

export type PhotoIdType = string;
export type LegalIdType = string;
 

export class SendMoneyPostValidationParameter extends BasicRequest {
	public Amount?: number;
	public FeeAmount?: number | null;
	public get FeeAmountFieldSpecified(): boolean { return this.FeeAmount != null; }
	public AgentCustomerNumber?: string;
	public DestinationCountry?: string;
	public DestinationState?: string;
	public DeliveryOption?: string;
	public ReceiveCurrency?: string;
	public ReceiveAgentId?: string;
	public AccountNumber?: string;
	public CustomerReceiveNumber?: string;
	public SenderFirstName?: string;
	public SenderMiddleName?: string;
	public SenderLastName?: string;
	public SenderLastName2?: string;
	public SenderAddress?: string;
	public SenderAddress2?: string;
	public SenderAddress3?: string;
	public SenderCity?: string;
	public SenderState?: string;
	public SenderZipCode?: string;
	public SenderCountry?: string;
	public SenderHomePhone?: string;
	public ReceiverFirstName?: string;
	public ReceiverMiddleName?: string;
	public ReceiverLastName?: string;
	public ReceiverLastName2?: string;
	public ReceiverAddress?: string;
	public ReceiverAddress2?: string;
	public ReceiverAddress3?: string;
	public Direction1?: string;
	public Direction2?: string;
	public Direction3?: string;
	public ReceiverCity?: string;
	public ReceiverState?: string;
	public ReceiverZipCode?: string;
	public ReceiverCountry?: string;
	public ReceiverPhone?: string;
	public TestQuestion?: string;
	public TestAnswer?: string;
	public MessageField1?: string;
	public MessageField2?: string;
	public SenderPhotoIdType?: PhotoIdType | null;
	public get SenderPhotoIdTypeFieldSpecified(): boolean { return this.SenderPhotoIdType != null; }
	public SenderPhotoIdNumber?: string;
	public SenderPhotoIdState?: string;
	public SenderPhotoIdCountry?: string;
	public SenderDOB?: Date | null;
	public get SenderDOBFieldSpecified(): boolean { return this.SenderDOB != null; }
	public SenderOccupation?: string;
	public SenderBirthCity?: string;
	public SenderBirthCountry?: string;
	public SenderPassportIssueDate?: Date | null;
	public get SenderPassportIssueDateFieldSpecified(): boolean { return this.SenderPassportIssueDate != null; }
	public SenderPassportIssueCity?: string;
	public SenderPassportIssueCountry?: string;
	public SenderLegalIdType?: LegalIdType | null;
	public get SenderLegalIdTypeFieldSpecified(): boolean { return this.SenderLegalIdType != null; }
	public SenderLegalIdNumber?: string;
	public SenderLegalIdIssueCountry?: string;
	public SenderEmailAddress?: string;
	public SenderMobilePhone?: string;
	public SendCurrency?: string;
	public ConsumerId?: string;
	public SenderPhotoIdExpDate?: Date | null;
	public get SenderPhotoIdExpDateFieldSpecified(): boolean { return this.SenderPhotoIdExpDate != null; }
	public SenderPhotoIdIssueDate?: Date | null;
	public get SenderPhotoIdIssueDateFieldSpecified(): boolean { return this.SenderPhotoIdIssueDate != null; }
	public SenderPhotoIdStored?: boolean | null;
	public get SenderPhotoIdStoredFieldSpecified(): boolean { return this.SenderPhotoIdStored != null; }
	public SenderNationalityCountry?: string;
	public SenderNationalityAtBirthCountry?: string;
	public AgentTransactionId?: string;
	public MgiTransactionSessionId?: string;
	public FormFreeStaging?: boolean;
	public get FormFreeStagingFieldSpecified(): boolean { return this.FormFreeStaging != null; }
	public TimeToLive?: string;
	public PrimaryReceiptLanguage?: string;
	public SecondaryReceiptLanguage?: string;
	public PromoCodeValues: string[] = [];
	public ConsumerRegistration?: ConsumerRegistration; 
	public ConsumerProfileUpdate?: boolean | null;
	public get ConsumerProfileUpdateFieldSpecified(): boolean { return this.ConsumerProfileUpdate != null; }
	public ProfilePreferenceId?: string;
	public FieldValues: Array<{ key: string; value: string }> = [];
	public mgiRewardsNumber?: string;
}

/** Not mapped from GFFP xmlTag via the generic string branch (handled elsewhere or collections). */
const EXCLUDED_FROM_SEND_VALIDATION_PROPERTY_KEY_MAP = new Set([
	"PromoCodeValues",
	"FieldValues",
	"ConsumerRegistration",
]);

let cachedMappableSendValidationPropertyNames: readonly string[] | undefined;

/**
 * Property names on this DTO that correspond to flat validation fields (C# SendMoneyPostValidationParameter / SetValuesForValidation).
 * Derived from the class instance so the list stays in sync with the model.
 */
export function getSendMoneyPostValidationMappablePropertyNames(): readonly string[] {
	if (!cachedMappableSendValidationPropertyNames) {
		const sample = new SendMoneyPostValidationParameter();
		cachedMappableSendValidationPropertyNames = Object.freeze(
			Object.keys(sample).filter((k) => !EXCLUDED_FROM_SEND_VALIDATION_PROPERTY_KEY_MAP.has(k))
		);
	}
	return cachedMappableSendValidationPropertyNames;
}